import React from 'react';
import { IconButton } from '@pypestream/design-system';
import { observer } from 'mobx-react-lite';

import {
  sendProStudioEvent,
  useProStudioCtxSelector,
} from '../../xstate/app.xstate';

export const CsvDownloader: React.FC = observer(() => {
  const { version } = useProStudioCtxSelector((ctx) => ({
    version: ctx.draft?.version || ctx.draftVersion || null,
  }));

  return (
    <IconButton
      size="small"
      name="download"
      onClick={() => {
        sendProStudioEvent({
          type: 'getVersionFile',
          version,
        });
      }}
    />
  );
});
